import React from 'react'
import { IconButtonProps, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material'
import { t } from 'i18next'
import TodayIcon from '@mui/icons-material/Today'
import { DateRangeIcon } from '@mui/x-date-pickers'

interface ToggleCalendarButtonProps extends IconButtonProps {
  isWeeklyRange: boolean
  changeMode:  () => void
}

const ToggleCalendarButton: React.FC<ToggleCalendarButtonProps> = ({
  isWeeklyRange,
  changeMode
}) => {
  return (
    <ToggleButtonGroup
      exclusive
      value={isWeeklyRange ? 'week' : 'day'}
      onChange={changeMode}
      sx={{ fontSize: '0.8rem', height: '30px', width: '74px' }}
    >
      <Tooltip title={t('components.tooltip.weeklyCalendar')}>
        <ToggleButton value={'week'} aria-label="dense layout">
          <DateRangeIcon sx={{ width: 14, color: 'text.highEmphasis' }} />
        </ToggleButton>
      </Tooltip>
      <Tooltip title={t('components.tooltip.dailyCalendar')}>
        <ToggleButton value={'day'} aria-label="scattered layout">
          <TodayIcon sx={{ width: 14, color: 'text.highEmphasis' }} />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  )
}

export default ToggleCalendarButton
